import * as React from 'react';
import styled from 'styled-components';
import { translate } from "react-i18next";
import {
    PHOTOS_TYPE,
    VIDEO_TYPE,
    SHP_TYPE,
    ORTO_TYPE,
    MODEL_TYPE,
    RESOURCE_TYPE,
    DTM_TYPE,
    DRONE_TYPE
} from '../../../../../types/upload';
import HiddenInfoSpan from '../../../../../components/HiddenInfoSpan';

const LeftAlignedP = styled.p`
  align-self: flex-start;
  margin: 5px 0px;
  white-space: pre-wrap;
  color: #265a9c;
  font-size: 14px;
  display: inline;
`;
const LeftAlignedDiv = styled.div`
  align-self: flex-start;
  margin: 5px 0px;
  white-space: pre-wrap;
  color: #265a9c;
  font-size: 14px;
  display: inline;
`;
const DescBold = styled.span`
  font-weight: bold;
`;

const UploadDescription = (props) => {
    const {
        type,
        t
    } = props;

    switch (type) {
        case PHOTOS_TYPE:
            return (<LeftAlignedP>
                {`${t('Photo file should countains EXIF metadata with photo location')}`}
            </LeftAlignedP>);
        case VIDEO_TYPE:
            return (<LeftAlignedP>
                {`${t('Only mp4 video format is supported')}`}
            </LeftAlignedP>);
        case SHP_TYPE:
            return (<React.Fragment>
                <LeftAlignedP>
                    {`${t('All files should be packed into zip format')}`}
                    <br />
                    {`${t('At least dbf, shp, shx and prj files are requeired')}`}
                </LeftAlignedP>
                {renderSupportedCSText(t, "Uploaded files should be in one of", true)}
            </React.Fragment>)
        case ORTO_TYPE:
            return (<React.Fragment>
                <LeftAlignedP>
                    {`${t('Orthophotomap should be in geotiff format with tiles')}`}
                </LeftAlignedP>
                {renderSupportedCSText(t, "Uploaded file should be in one of", true)}
            </React.Fragment>);
        case DRONE_TYPE:
            return (<LeftAlignedP>
                {`${t('Only DJI flight logs are supported')}`}
            </LeftAlignedP>);
        case RESOURCE_TYPE:
            return (<LeftAlignedP>
                {`${t('Attachment could be a file of any type')}`}
            </LeftAlignedP>);
        case MODEL_TYPE:
            return (<LeftAlignedP>
                {`${t('Only sketchfab links are supported')}`}
            </LeftAlignedP>);
        case DTM_TYPE:
            return (<React.Fragment>
                {renderSupportedCSText(t, "Uploaded file should be in one of", false)}
            </React.Fragment>);
        default:
            return (null);
    }
};

const renderSupportedCSText = (t, startText, withBr) => {
    return <LeftAlignedDiv>
        {withBr && <br />}
        {withBr && <br />}
        {`${t(startText)} `}
        <DescBold>{`${t('the supported coordinate systems')}`}</DescBold>
        <HiddenInfoSpan title={"i"} text={getSupportedText(t)}></HiddenInfoSpan>
    </LeftAlignedDiv>;
}

const getSupportedText = (t) => {
    return [t('WGS84 is the recommended coordinate system'),
    t('The other supported coordinate systems'),
    t('OSGB 1936')];
}

export default translate("translations")(UploadDescription);


// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/uploadDescription/UploadDescription.jsx